export default "__VITE_ASSET__GK4$bIOT__"